/**
 * Auto-generated i18n messages.
 * DO NOT EDIT THIS FILE MANUALLY.
 */

export type GeneratedMessages = Record<string, Record<string, unknown>>;

export const messages: GeneratedMessages = {
  "fr": {
    "commonFrontend": {
      "misc": {
        "noResult": "Aucun résultat",
        "other": "Autre"
      },
      "site-tree-structure": {
        "title": "Structure du site",
        "searchSection": "Rechercher un espace"
      },
      "site-sections-tree": {
        "appliance-count": "Aucun équipement | 1 équipement | {count} équipements",
        "section-appliances": {
          "title": "Équipements",
          "move-appliances": "Déplacer des équipements",
          "see-all": "Voir tous les équipements ({count})"
        }
      },
      "applianceCategory": {
        "HEATER": "Chauffage",
        "AC_UNIT_NON_INFRARED": "Climatisation",
        "WATER_HEATER": "Chauffe-eau"
      }
    },
    "authentication": {
      "title": {
        "welcome": "Bienvenue !",
        "subtitle": "Veuillez saisir votre adresse email et votre mot de passe."
      },
      "email": {
        "label": "Email",
        "placeholder": "Votre email"
      },
      "password": {
        "label": "Mot de passe",
        "placeholder": "Votre mot de passe"
      },
      "login": "Connexion",
      "error": "Identifiants incorrects, veuillez réessayer.",
      "forgotPassword": {
        "link": "Mot de passe oublié ?",
        "title": "Récupération du mot de passe",
        "subtitle": "Saisissez l’adresse e-mail que vous utilisez pour enterprise.voltalis.com",
        "label": "Votre adresse e-mail professionnelle",
        "placeholder": "Saisissez votre adresse e-mail",
        "success": "Vous allez recevoir un mail pour récupérer votre mot de passe"
      },
      "passwordRecovery": {
        "newPassword": "Nouveau mot de passe",
        "subtitle": "Créez un nouveau mot de passe sécurisé pour protéger votre compte.",
        "message": "Pour plus de sécurité, évitez les informations personnelles ou les mots de passe déjà utilisés.",
        "success": "Votre mot de passe a bien été mis à jour."
      },
      "activation": {
        "title": "Bienvenue dans votre espace !",
        "subtitle": "Avant de commencer, vous devez créer votre mot de passe pour accéder à votre compte.",
        "message": "Utilisez un mot de passe unique et complexe.",
        "createPassword": "Créer mon mot de passe"
      }
    },
    "components": {
      "contact-voltalis-dialog": {
        "title": "Contacter Voltalis",
        "subtitle": "Pour toute question, n'hésitez pas à nous contacter",
        "form": {
          "site-id": {
            "label": "Site concerné"
          }
        }
      },
      "programmingGantt": {
        "messages": {
          "deleteSchedule": {
            "success": "Le pilotage a été supprimé",
            "error": "Erreur lors de la suppression du pilotage. Merci de réessayer ultérieurement..."
          }
        },
        "siteHasNoSection": {
          "title": "Aucun espace pour ce type d'équipement",
          "subtitle": "Le site ne possède aucun espace avec le type d'équipement sélectionné pouvant être piloté"
        }
      },
      "layout": {
        "sideMenu": {
          "control": "Commande",
          "piloting": "Pilotage",
          "programming": "Programmes",
          "data": "Données",
          "dashboard": "Tableau de bord",
          "consumptionMonitoring": "Suivi de consommation",
          "tools": "Outils",
          "sitesManagement": "Gestion du site | Gestion des sites",
          "newSitesManagement": "Gestion du site | Gestion des sites",
          "settings": "Paramètres",
          "contact": "Contacter Voltalis",
          "logout": "Se déconnecter",
          "dialog": {
            "logoutConfirmation": "Êtes-vous sûr de vouloir vous déconnecter ?"
          }
        },
        "breadcrumb": {
          "consumption-monitoring": "Suivi de consommation",
          "dashboard-monosite": "Consommation site",
          "dashboard-view": "Tableau de bord",
          "piloting": "Pilotage",
          "planning": "Planning de pilotage",
          "programming": "Programmes",
          "programming-creation": "Nouveau programme",
          "new-programming-creation": "Nouveau programme",
          "programming-list": "Liste des programmes",
          "new-programming-list": "Liste des programmes",
          "programming-details": "Détail d'un programme",
          "new-programming-details": "Détail d'un programme",
          "section-management": "Ancienne Gestion des sites",
          "new-section-management": "Gestion des sites",
          "site-sections": "Liste des espaces",
          "site-sections-tree": "Arborescence des espaces",
          "activation": "Activation",
          "site-consumption-monitoring": "Suivi de consommation site",
          "home": "Accueil",
          "login": "Connexion",
          "password-recovery": "Récupération de mot de passe"
        },
        "error404": {
          "title": "Page introuvable",
          "subtitle": "La page que vous essayez de consulter est introuvable"
        }
      },
      "passwordCreation": {
        "newPassword": "Nouveau mot de passe",
        "passwordConfirmation": "Confirmation mot de passe",
        "passwordShouldContain": "Votre mot de passe devra contenir",
        "atLeast10Char": "Au moins 10 caractères",
        "oneUppercase": "Une majuscule",
        "oneLowercase": "Une minuscule",
        "oneNumber": "Un chiffre",
        "oneSpecialCharacter": "{'Un caractère spécial (ex : @, #, !)'}",
        "success": "Votre mot de passe a bien été mis à jour"
      },
      "selectProgram": {
        "noResult": "Aucun programme appliquable."
      },
      "programApplianceStepperCard": {
        "disabledApplianceTooltip": "Configurez l'équipement en cours avant de passer au suivant"
      }
    },
    "control": {
      "piloting": {
        "title": "Pilotage",
        "siteSectionsTree": "Arborescence du site",
        "subtitle": "Piloter les sites par espace",
        "zoomIn": "Zoomer",
        "zoomOut": "Dézoomer",
        "siteProgramingSuspendedWarning": "Pilotage Voltalis suspendu",
        "siteHasSuspendedProgramingWarning": "Le pilotage de votre site par Voltalis est suspendu",
        "siteHasSuspendedProgramingWarningDetails": "Le pilotage et la programmation Voltalis ont été suspendus. Pour gérer vos équipements, utilisez les réglages manuels de ceux-ci",
        "planning": {
          "title": "Planning de pilotage",
          "subtitle": "Sélectionnez les espaces, puis appliquez un programme.",
          "accessLegacyPiloting": "Accéder au pilotage legacy",
          "defaultProgram": "Programme par défaut",
          "form": {
            "title": {
              "create": "Appliquer un programme",
              "edit": "Modifier un programme"
            },
            "countSelectedSections": "1 espace pilotable sélectionné | {count} espaces pilotables sélectionnés",
            "startDate": "Date de début",
            "startTime": "Heure de début",
            "endDate": "Date de fin",
            "endTime": "Heure de fin",
            "indefinitePeriod": "Durée indéterminée"
          },
          "createProgrammingRange": {
            "success": "La programmation a bien été plannifiée.",
            "error": "Une erreur est survenue lors de la création de la programmation."
          },
          "updateProgrammingRange": {
            "success": "La programmation a bien été modifiée.",
            "error": "Une erreur est survenue lors de la modification de la programmation."
          },
          "deleteProgrammingRange": {
            "title": "Supprimer cette programmation ?",
            "subtitle": "Cette action est irréversible. La programmation sera définitivement supprimée et ne s'appliquera plus à cet espace.",
            "success": "La programmation a bien été supprimée.",
            "error": "Une erreur est survenue lors de la suppression de la programmation."
          },
          "programmingRangeActions": "Actions pour {name}"
        }
      },
      "programming": {
        "title": "Programmes",
        "subtitle": "Gérer les programmes du site",
        "programList": "Liste des programmes",
        "searchProgram": "Rechercher un programme...",
        "createProgram": "Créer programme",
        "newProgram": "Nouveau programme",
        "defaultProgram": "Programme par défaut",
        "countPrograms": "Aucun programme | 1 programme | {count} programmes",
        "customProgramsCount": "Aucun programme personnalisé | 1 programme personnalisé | {count} programmes personnalisés",
        "activation": {
          "error": "Une erreur est survenue lors de l'activation d'un programme."
        },
        "creation": {
          "title": "Créer un programme",
          "subtitle": "Configuration d'un nouveau programme",
          "programName": "Nom du programme",
          "error": "Une erreur est survenue lors de la création d'un nouveau programme."
        },
        "clone": {
          "action": "Dupliquer"
        },
        "copyToOtherSite": {
          "action": "Copier vers un autre site",
          "title": "Copier {name} vers un autre site",
          "subtitle": "Copier un programme existant vers un site différent",
          "targetSite": "Site cible",
          "success": "Le programme a bien été dupliqué.",
          "error": "Une erreur est survenue lors de la copie du programme."
        },
        "renaming": {
          "title": "Renommer un programme",
          "error": "Une erreur est survenue lors du renommage du programme."
        },
        "deletion": {
          "title": "Supprimer le programme",
          "subtitle": "Vous êtes sur le point de supprimer le programme {name}.",
          "success": "Le programme a bien été supprimé.",
          "error": "Une erreur est survenue lors de la suppression du programme."
        },
        "details": {
          "title": "Programme {name}",
          "subtitle": "Configuration d’un programme affectant l’établissement {siteName}",
          "businessDays": "Jours ouvrés",
          "weekend": "Week-end",
          "dayDuplication": {
            "title": "Dupliquer {day}",
            "subtitle": "Copier le planning de ce jour vers :",
            "allDays": "Tous les jours",
            "workingDays": "Jours ouvrés",
            "weekend": "Week-end"
          },
          "dayOptions": "Options pour {day}",
          "saveProgram": "Enregistrer programme",
          "editProgram": "Modifier le programme",
          "loadError": "Le programme n’a pas pu être chargé.",
          "retry": "Réessayer",
          "identity": {
            "creationSubtitle": "Configuration d’un nouveau programme affectant l’établissement",
            "detailsSubtitle": "Configuration du programme affectant l’établissement",
            "title": "Identité",
            "programName": "Nom du programme",
            "programNamePlaceholder": "Nom du programme",
            "programNameRequired": "Le nom du programme est obligatoire.",
            "programColor": "Couleur du programme"
          },
          "appliances": {
            "title": "Équipements",
            "configure": "Configurer l’équipement",
            "configureNext": "Configurer l’équipement suivant",
            "loadError": "Les équipements de l’établissement n’ont pas pu être chargés. La création du programme est indisponible.",
            "validateProgram": "Valider le programme"
          },
          "quickConfigurations": {
            "title": "Configuration rapide",
            "subtitle": "Appliquer à l’équipement :",
            "weekendOff": "Arrêt le week-end",
            "everyDayOn": "Marche tous les jours",
            "nightOff": "Arrêt la nuit",
            "weekdaysEco": "Eco jours ouvrés",
            "everyDayComfort": "Confort tous les jours",
            "nightFrost": "Hors-gel la nuit"
          },
          "cancel": "Annuler",
          "edit": {
            "success": "Le programme a bien été enregistré.",
            "error": "Une erreur est survenue lors de l'enregistrement du programme."
          },
          "unsavedChanges": {
            "title": "Modifications non enregistrées",
            "message": "Vos modifications seront perdues si vous quittez sans les enregistrer.",
            "discard": "Abandonner les modifications",
            "continueEditing": "Continuer la modification"
          }
        },
        "range": {
          "addition": "Ajouter une plage horaire",
          "edition": "Modifier la plage horaire",
          "subtitle": "Configuration du programme",
          "deletion": {
            "title": "Suppression du programme",
            "confirmationMessage": "Êtes-vous sûr de vouloir supprimer le programme {mode} du {day} ({startTime} à {endTime}) ?"
          },
          "error": {
            "cannotDeleteLastRange": "Impossible de supprimer le seul programme du {day}",
            "minThreshold": "Un programme doit durer au moins 30 minutes",
            "endInferiorToStart": "L'heure de fin ne peut pas être inférieure à l'heure de début",
            "emptyRange": "Une journée ne peut pas être composée de créneau vide",
            "mandatoryMode": "Veuillez sélectionner un mode"
          },
          "applianceType": "Type d'équipement",
          "availableInstructions": "Consignes disponibles",
          "startTime": "Début",
          "endTime": "Fin",
          "mode": "Mode",
          "temperature": "Température (°C)",
          "multipleApplications": "Application multiple",
          "applyOnBusinessDays": "Appliquer aux jours ouvrés",
          "applyOnWeekEnd": "Appliquer au weekend",
          "temperatureMode": "Température"
        }
      }
    },
    "data": {
      "dashboard": {
        "title": "Tableau de bord",
        "emptySitePerimeter": "Vous n'avez accès à aucun site",
        "subtitle": {
          "MONOSITE": "Données de coûts et consommations des espaces du {fromDate} au {toDate}",
          "MULTISITE": "Données de coûts et de consommation des sites du {fromDate} au {toDate}"
        },
        "insights": {
          "title": "Résumé énergétique",
          "totalConsumption": {
            "title": {
              "MONOSITE": "Conso. Globale Site",
              "MULTISITE": "Conso. Globale Sites"
            },
            "tooltip": {
              "MONOSITE": "Donnée de consommation fournie par Enedis, qui regroupe la consommation électrique de tout votre site.\n\n            Elle est agrégée sur la période indiquée.",
              "MULTISITE": "Donnée de consommation fournie par Enedis, qui regroupe la consommation électrique de tous vos sites.\n\n            Elle est agrégée sur la période indiquée."
            },
            "missingDsoSubscription": "Données fournisseurs manquantes",
            "subtitle": {
              "MONOSITE": "Sur les 30 derniers jours",
              "MULTISITE": "Soit {average} par site (moyenne)"
            }
          },
          "equipmentConsumption": {
            "title": "Conso. équipements",
            "tooltip": {
              "MONOSITE": "Données de consommation récupérée par les équipements installés par Voltalis sur la totalité de votre site.\n\n            Elle est agrégée sur la période indiquée.",
              "MULTISITE": "Donnée de consommation récupérée par les équipements installés par Voltalis sur la totalité de vos sites.\n\n            Elle est agrégée sur la période indiquée."
            },
            "subtitle": "Soit {percent}% de la consommation globale"
          },
          "m2Consumption": {
            "title": "Conso. au m²",
            "tooltip": {
              "DSO": "C’est la division de la {sitesConsumption} et de la superficie déclarée dans l’onglet {sitesManagementTab}.",
              "DEVICES": "C’est la division de la {sitesConsumption} et de la superficie déclarée dans l’onglet {sitesManagementTab}.",
              "fallback": "C'est la division de la consommation et de la superficie déclarée dans l’onglet {sitesManagementTab}."
            },
            "subtitle": "Soit {amount}€/m2",
            "missingSurfaceArea": "Action requise · Superficie manquante | Action requise · Superficie des sites manquante"
          },
          "consumptionEvolution": {
            "title": {
              "DSO": "Évolution conso. globale site | Évolution conso. globale sites",
              "DEVICES": "Évolution conso. équipements",
              "fallback": "Évolution consommation"
            },
            "tooltip": {
              "DSO": "C’est la variation de la {sitesConsumption} de l’année N avec celle de l’année N-1 sur la période indiquée.",
              "DEVICES": "C’est la variation de la Consommation des équipements de vos sites de l’année N avec celle de l’année N-1 sur la période indiquée.",
              "fallback": "C'est la variation de la consommation de l'année N avec celle de l'année N-1 sur la période indiquée."
            },
            "subtitle": "Comparé à la période précédente",
            "highVariation": {
              "warning": "Variation importante",
              "details": "Une forte variation peut simplement indiquer que votre parc d'équipements n'était pas encore entièrement déployé l'année dernière."
            }
          },
          "totalCost": {
            "title": {
              "DSO": "Tarif global estimé",
              "DEVICES": "Tarif équipements estimé",
              "fallback": "Coût estimé"
            },
            "tooltip": "C’est le prix du kWh d'électricité déclaré dans l’onglet {sitesManagementTab} multiplié par la {sitesConsumption}.\n\n            ⚠️ Ce coût est une estimation, il ne prend en compte ni les taxes ni l’abonnement dans votre contrat. Pour récupérer une donnée plus précise, veuillez vous rapprocher vers votre fournisseur d'électricité.",
            "subtitle": "Dont {amount} € liés aux équipements"
          },
          "ranking": {
            "title": {
              "MONOSITE": "Podium des espaces les moins consommateurs",
              "MULTISITE": "Podium des sites les moins consommateurs"
            },
            "tooltip": {
              "MONOSITE": "Les espaces ayant la plus faible consommation électrique sur la période indiquée sont mis en avant sur ce graphique.\n\n            La consommation électrique d’un espace est le cumul de la consommation de tous les équipements de l’espace installés avec des modules Voltalis.",
              "MULTISITE": "Les sites ayant la plus faible consommation électrique sur la période indiquée sont mis en avant sur ce graphique.\n\n            La consommation électrique d’un site est le cumul de la consommation de tous les points de livraison (PDL) associés. Cette donnée est fournie par Enedis quotidiennement."
            }
          }
        },
        "consumptionChart": {
          "title": "Consommation",
          "tooltip": {
            "MONOSITE": "Ce graphique affiche la {sitesConsumption} ainsi que sa {equipmentConsumption} au pas quotidien.\n\n          Ces données sont agrégées sur la période indiquée.",
            "MULTISITE": "Ce graphique affiche la {sitesConsumption} de tout votre parc ainsi que sa {equipmentConsumption}.\n\n          Ces données sont agrégées sur la période indiquée.",
            "estimated": {
              "MONOSITE": "Ce graphique affiche la {sitesConsumption} estimée ainsi que sa {equipmentConsumption} au pas quotidien.\n\n            Ces données sont agrégées sur la période indiquée.\n\n            Dans l’attente des données du gestionnaire de réseau, Voltalis calcule une estimation de vos données de consommation.",
              "MULTISITE": "Ce graphique affiche la {sitesConsumption} estimée de tout votre parc ainsi que sa {equipmentConsumption}.\n\n            Ces données sont agrégées sur la période indiquée.\n\n            Dans l’attente des données du gestionnaire de réseau, Voltalis calcule une estimation de vos données de consommation."
            }
          },
          "totalConsumption": {
            "name": "Consommation totale",
            "description": {
              "MONOSITE": "La consommation électrique du site sur la période indiquée. Cette donnée est fournie par Enedis.",
              "MULTISITE": "La consommation des sites dans le périmètre de l’utilisateur sur la période indiquée. Cette donnée est fournie par Enedis."
            }
          },
          "applianceConsumption": {
            "name": "Consommation des équipements",
            "description": {
              "MONOSITE": "La consommation électrique cumulée des équipements du site possédant des modules Voltalis, sur la période indiquée.",
              "MULTISITE": "La consommation électrique cumulée des équipements des sites possédant des modules Voltalis, sur la période indiquée."
            }
          }
        },
        "areaConsumptionChart": {
          "title": "Consommation au m²",
          "tooltip": {
            "MONOSITE": "C’est la consommation totale des équipements Voltalis d’un espace divisé par sa surface, renseignée dans l’onglet {sitesManagementTab}.\n\n          Ces données sont agrégées sur la période indiquée.",
            "MULTISITE": "C’est la consommation totale d’un site divisé par sa surface totale renseignée dans l’onglet {sitesManagementTab}.\n\n          Ces données sont agrégées sur la période indiquée."
          },
          "legend": {
            "MONOSITE": "Consommation de l'espace au m²",
            "MULTISITE": "Consommation du site au m²"
          },
          "description": {
            "MONOSITE": "La consommation électrique au m² cumulée sur la période indiquée de chaque espace",
            "MULTISITE": "La consommation électrique au m² cumulée sur la période indiquée de chaque site"
          }
        },
        "consumptionComparisonChart": {
          "title": "Évolution de la consommation",
          "tooltip": {
            "DSO": "Ce graphique représente l'évolution de la {sitesConsumption} de l’année N avec celle de l’année N-1.",
            "DEVICES": "Ce graphique représente l'évolution de la {equipmentConsumption} de l’année N avec celle de l’année N-1.",
            "fallback": "Ce graphique représente l'évolution de la consommation de l'année N avec celle de l'année N-1"
          },
          "lastPeriod": {
            "description": {
              "MONOSITE": "La consommation de l’espace, sur la période indiquée de l’année précédente.",
              "MULTISITE": "La consommation du site fournie par Enedis, sur la période indiquée de l’année précédente."
            }
          },
          "currentPeriod": {
            "description": {
              "MONOSITE": "La consommation de l’espace, sur la période indiquée de l’année en cours",
              "MULTISITE": "La consommation du site fournie par Enedis, sur la période indiquée de l’année en cours"
            }
          }
        },
        "deviceConsumptionDistribution": {
          "title": "Répartition de la consommation des équipements",
          "subtitle": "Basée sur {amount} équipements Voltalis",
          "deviceCategory": {
            "HEATER": "Chauffage",
            "WATER_HEATER": "Chauffe-eau",
            "AIR_CONDITIONING_COOLING": "Clim",
            "HEAT_PUMP": "Pompe à chaleur",
            "OTHER": "Autre"
          },
          "tooltip": "Ce graphique montre la répartition de la {equipmentConsumption} installés par Voltalis.\n\n          Les équipements non installés par Voltalis sont regroupés dans la catégorie “Autre”.\n\n          Ces données sont agrégées sur la période indiquée.",
          "description": {
            "MONOSITE": "La distribution de la consommation électrique sur la période indiquée, entre les équipements installés sur le site",
            "MULTISITE": "La distribution de la consommation électrique sur la période indiquée, entre les équipements installés sur les sites"
          }
        },
        "topFlops": {
          "highestConsumption": {
            "MONOSITE": "Espaces les plus énergivores",
            "MULTISITE": "Sites les plus énergivores"
          },
          "highestPositiveEvolution": {
            "MONOSITE": "Espaces avec la plus forte hausse de consommation (Y/Y)",
            "MULTISITE": "Sites avec la plus forte hausse de consommation (Y/Y)"
          },
          "highestNegativeEvolution": {
            "MONOSITE": "Espaces avec la plus forte baisse de consommation (Y/Y)",
            "MULTISITE": "Sites avec la plus forte baisse de consommation (Y/Y)"
          }
        },
        "consumptionHeatmap": {
          "title": {
            "DSO": "Consommation du site (12 mois, jour par jour) | Consommation des sites (12 mois, jour par jour)",
            "DEVICES": "Consommation des équipements du site (12 mois, jour par jour) | Consommation des équipements des sites (12 mois, jour par jour)",
            "fallback": "Consommation (12 mois, jours par jour)"
          }
        },
        "messages": {
          "noData": {
            "MONOSITE": {
              "accessDataMessage": "Certaines consommations de votre {action} ne sont pas disponibles. Veuillez contacter un conseiller Voltalis pour en savoir plus.",
              "action": "conso.totale"
            },
            "MULTISITE": {
              "accessDataMessage": "Certaines consommations de votre {action} ne sont pas disponibles. Veuillez contacter un conseiller Voltalis pour en savoir plus. ",
              "action": "conso.sites"
            }
          },
          "missingConsents": {
            "contactVoltalis": "Pour accéder à vos données de consommation, veuillez {contactLink}",
            "contactLink": "contacter Voltalis",
            "prefilledDescription": "Je souhaite accéder à mes données de consommation"
          }
        },
        "missingInfos": {
          "title": "Données manquantes",
          "subtitle": {
            "MONOSITE": "Les données suivantes sont manquantes. Pour les compléter, veuillez vous rendre dans la Gestion du site.",
            "MULTISITE": "Les données suivantes sont manquantes. Pour les compléter, veuillez vous rendre dans la Gestion des sites."
          },
          "MONOSITE": {
            "goToSiteManagement": "Aller à la gestion du site",
            "missingPrice": "Coûts manquants",
            "missingSiteArea": "Superficie manquante",
            "missingSiteSectionArea": "Superficies d'un ou plusieurs espaces manquantes"
          },
          "MULTISITE": {
            "missingSurfaceArea": "Superficie manquante",
            "missingConsumptionCost": "Coûts manquants"
          }
        },
        "missingDsoSubscriptionDialog": {
          "title": "Absence de données de consommation globale",
          "subtitle": "Les données du fournisseur d’énergie ne sont pas encore disponibles.",
          "content": {
            "MONOSITE": "La consommation globale du site n’est pas encore disponible. Cela s’explique par le fait que les données issues du fournisseur d’énergie ne peuvent être affichées que si le partage de ces informations a été autorisé.\n\n            Pour accéder à la consommation globale de votre site, nous vous invitons à contacter Voltalis afin d’activer le partage de vos données fournisseurs.",
            "MULTISITE": "La consommation globale de vos sites n’est pas encore disponible. Cela s’explique par le fait que les données issues du fournisseur d’énergie ne peuvent être affichées que si le partage de ces informations a été autorisé sur l'ensemble de vos sites.\n\n            Pour accéder à la consommation globale de vos sites, nous vous invitons à contacter Voltalis afin d’activer le partage de vos données fournisseurs."
          }
        },
        "missingSurfaceArea": {
          "title": "Superficie manquante",
          "subtitle": {
            "partial": {
              "MONOSITE": "La consommation au m² ne peut pas être calculée car la superficie d’un ou plusieurs espaces n’est pas renseignée. Veuillez les renseigner dans dans l’onglet {sitesManagementTab}.",
              "MULTISITE": "La consommation au m² ne peut pas être calculée car la superficie d’un ou plusieurs sites n’est pas renseignée."
            },
            "total": {
              "MONOSITE": "La consommation au m² ne peut pas être calculée car aucune superficie n’est renseignée dans les espaces de votre site. Veuillez les renseigner dans l’onglet {sitesManagementTab}.",
              "MULTISITE": "La consommation au m² ne peut pas être calculée car aucune superficie de site n'est renseignée."
            }
          }
        },
        "noDataChartMessage": {
          "title": "Informations requises pour afficher ce graphique",
          "noInstalledDevices": "Aucun {installedDevices}. Impossible d’afficher les informations de ce graphique.",
          "installedDevices": "équipement n’est installé actuellement"
        },
        "selectPerimeter": {
          "title": "Sélection du périmètre",
          "submit": "Confirmer la sélection",
          "selected": "Périmètre sélectionné"
        },
        "error": "Une erreur est survenue lors de la récupération des données du site. Veuillez réessayer."
      },
      "consumptionMonitoring": {
        "subtitle": "Suivre la consommation des sites du {fromDay} au {toDay}",
        "sitesDataTable": {
          "header": {
            "siteName": "Nom du site",
            "sections": "Espaces",
            "appliances": "Équipements",
            "consumption": {
              "DSO": "Conso. globale",
              "DEVICES": "Conso. équipement",
              "fallback": "Consommation"
            },
            "subtitle": {
              "bySite": "Par site",
              "last30days": "30 derniers jours"
            }
          }
        },
        "siteMonitoring": {
          "title": "Consommation d'un site",
          "backToSitesList": "Retour à la liste des sites",
          "sectionPerimeter": {
            "selectPerimeter": "Sélectionner un périmètre d'espaces",
            "multipleSectionSelection": "Sélection d'espaces"
          },
          "tabs": {
            "temporalConsumptionChart": "Consommation globale",
            "consumptionComparisonChart": "Évolution de la consommation",
            "areaConsumptionChart": "Consommation au m²",
            "calendarHeatmapChart": "Heatmap"
          }
        }
      }
    },
    "global": {
      "locale": {
        "fr": "Français",
        "en": "Anglais"
      },
      "weekDays": {
        "1": "Lundi",
        "2": "Mardi",
        "3": "Mercredi",
        "4": "Jeudi",
        "5": "Vendredi",
        "6": "Samedi",
        "7": "Dimanche"
      },
      "units": {
        "temporal": {
          "SECOND": "Seconde | Secondes | {count} Secondes",
          "MINUTE": "Minute | Minutes | {count} Minutes",
          "HOUR": "Heure | Heures | {count} Heures",
          "DAY": "Jour | Jours | {count} Jours",
          "WEEK": "Semaine | Semaines | {count} Semaines",
          "MONTH": "Mois | Mois | {count} Mois",
          "QUARTER": "Trimestre | Trimestres | { count } Trimestres",
          "YEAR": "Année | Années | {count} Années"
        },
        "dateScaling": {
          "shortWeek": "S{number}",
          "shortQuarter": "T{number}"
        },
        "Wh": "{value} {prefix}Wh",
        "CELSIUS": "{value}°C",
        "€": "{value} €",
        "%": "{value} %",
        "kg": "{value} kg",
        "m²": "{value} m²"
      },
      "site": "site",
      "allSites": "Tous les sites",
      "searchSite": "Rechercher un site...",
      "section": "espace",
      "consumption": "Consommation",
      "count": {
        "sites": "Aucun site | 1 site | {count} sites",
        "appliances": "Aucun équipement | 1 équipement | {count} équipements",
        "section": "Aucun espace | 1 espace | {count} espaces"
      },
      "noData": "Aucune donnée",
      "missingData": "Donnée manquante",
      "invalidForm": "Formulaire invalide, veillez à ce que tous les champs soient valides.",
      "misc": {
        "add": "Ajouter",
        "apply": "Appliquer",
        "back": "Retour",
        "cancel": "Annuler",
        "change": "Changer",
        "clearAll": "Tout effacer",
        "close": "Fermer",
        "confirm": "Confirmer",
        "copied": "Copié",
        "copy": "Copier",
        "copyOf": "Copie de {name}",
        "create": "Créer",
        "dateFrom": "Du",
        "dateTo": "Au",
        "delete": "Supprimer",
        "deletePermanently": "Supprimer définitivement",
        "details": "Détails",
        "duration": "Durée",
        "edit": "Modifier",
        "later": "Plus tard",
        "next": "Suivant",
        "no": "Non",
        "noResult": "Aucun résultat",
        "noResultSearchHelpText": "\n        Nous n'avons trouvé aucun résultat correspondant à votre recherche.\n        Merci de vérifier vos critères ou d'ajuster vos filtres pour explorer plus d'options\n      ",
        "optional": "optionnel",
        "other": "Autre",
        "paste": "Coller",
        "permanentAction": "Cette action est définitive et irréversible.",
        "pilot": "Piloter",
        "previous": "Précédent",
        "program": "Programme",
        "refresh": "Rafraîchir",
        "rename": "Renommer",
        "save": "Enregistrer",
        "search": "Rechercher",
        "selectAll": "Tout sélectionner",
        "send": "Envoyer",
        "sort": "Trier",
        "submit": "Valider",
        "today": "Aujourd'hui",
        "unselectAll": "Tout désélectionner",
        "yes": "Oui"
      },
      "program": {
        "metaMode": {
          "CONFORT": "Confort",
          "ECO": "Eco",
          "HORS_GEL": "Hors-gel",
          "PROGRAMMING": "Programme",
          "ON": "Marche",
          "TEMPERATURE": "Temp.",
          "OFF": "Arrêt",
          "OCCUPIED": "Occupé",
          "AVAILABLE": "Disponible",
          "equivalent": {
            "CONFORT": "Équivalent à 20°C",
            "ECO": "Équivalent à 17°C",
            "HORS_GEL": "Équivalent à 7°C"
          }
        }
      },
      "applianceCategory": {
        "HEATER": "Chauffage",
        "AC_UNIT_NON_INFRARED": "Clim (non IR)",
        "AIR_HANDLING_UNIT": "Centrale de traitement d'air",
        "BOILER": "Chaudière",
        "CHARGING_STATION": "Borne de recharge",
        "CHILLER": "Groupe froid",
        "CHILLER_FOOD_GRADE": "Groupe froid alimentaire",
        "GENERATOR_SET": "Groupe électrogène",
        "HEATER_STORAGE": "Accumulateur",
        "HEATER_UNIT": "Aérotherme",
        "HEATING_FLOOR": "Plancher chauffant",
        "HEAT_PUMP": "PAC",
        "HEAT_PUMP_DHW": "PAC ECS",
        "HEAT_PUMP_WITH_TEMPERATURE": "PAC avec T°",
        "POOL_HEATER": "Réchauffeur de piscine",
        "PUMP_MOTOR": "Moteur Pompe",
        "RADIANT_CEILING_PANEL": "Plafond rayonnant",
        "WATER_HEATER": "Chauffe-eau",
        "BOOKABLE_SPACE": "Espace programmable"
      },
      "filters": {
        "hide": "Cacher les filtres",
        "show": "Afficher les filtres"
      },
      "applianceType": {
        "appliances": {
          "heater": "Chauffage",
          "underfloorHeating": "Sol chauffant",
          "waterHeater": "Chauffe-eau"
        }
      },
      "roomType": {
        "bathroom": "Salle de bain",
        "bedroom": "Chambre",
        "entrance": "Entrée",
        "hallway": "Couloir",
        "kitchen": "Cuisine",
        "lounge": "Salon/Salle à manger",
        "office": "Bureau",
        "other": "Autre"
      },
      "tarifType": {
        "offPeakHours": "HC",
        "peakHours": "HP"
      },
      "fullTarifType": {
        "offPeakHours": "Heures creuses",
        "peakHours": "Heures pleines"
      }
    },
    "error": {
      "default": "Une erreur est survenue, veuillez réessayer.",
      "form": "Erreur dans le formulaire : {errors}",
      "DUPLICATE_PROGRAM_NAME_FOR_SAME_SITE": "\n      Ce nom de programme existe déjà dans le site cible. Veuillez saisir un nom différent.\n    ",
      "ACTIVE_PROGRAMS_CANNOT_BE_DELETED": "Impossible de supprimer un programme actif.",
      "USER_ACCOUNT_ALREADY_ACTIVATED": "Erreur : Votre mot de passe a déjà été défini précédemment. Veuillez vous connecter.",
      "ACTIVATION_CODE_EXPIRED": "Erreur : Le lien pour définir votre mot de passe a expiré. Veuillez nous contacter.",
      "RECOVERY_CODE_EXPIRED": "Erreur : Le lien pour définir votre mot de passe a expiré. Veuillez nous contacter.",
      "EMAIL_ADDRESS_INVALID_FORMAT": "Adresse email invalide",
      "PHONE_NUMBER_INVALID_FORMAT": "Numéro de téléphone invalide",
      "INTEGER_INVALID_VALUE": "Nombre invalide",
      "INTEGER_NEGATIVE": "Ne peut pas avoir une valeur négative",
      "INVALID_VALUE": "Valeur invalide",
      "IS_BLANK": "Ne doit pas être vide",
      "IS_EMPTY": "Ne doit pas être vide",
      "NOT_STRONG_ENOUGH_PASSWORD": "Mot de passe trop simple",
      "STRING_MAX_SIZE_EXCEEDED": "Valeur trop longue",
      "STRING_MIN_SIZE_NOT_REACHED": "Valeur trop courte",
      "STRING_WRONG_FIXED_SIZE": "La valeur ne respecte pas la longueur attendue",
      "UNEXPECTED_VALUE": "Valeur inattendue",
      "WRONG_STRING_CODE_FORMAT": "Mauvais format de code",
      "WRONG_STRING_NAME_FORMAT": "Mauvais format de nom",
      "WRONG_STRING_RELAXED_NAME_FORMAT": "La valeur du texte est invalide",
      "SITE_SECTION_ALREADY_EXISTS_WITH_SAME_NAME": "Un espace porte déjà ce nom.",
      "SITE_SECTION_CATEGORY_NAME_EXISTS_ON_SITE": "Une catégorie avec ce nom existe déjà sur ce site."
    },
    "tools": {
      "siteManagement": {
        "title": "Gestion des sites",
        "subtitle": "Gérer les sites",
        "siteDetails": {
          "surfaceArea": "Superficie (m²)",
          "kWhCost": "Coût du kWh (€)",
          "edition": {
            "title": "Modification du site",
            "editionMode": "Mode édition",
            "changesNotSavedYet": "Les modifications ne sont pas encore enregistrées",
            "informations": "Informations",
            "siteName": "Nom du site",
            "label": {
              "pointe": "Heures de pointe (€)",
              "hp": "Heures pleines (€)",
              "hc": "Heures creuses (€)",
              "hpe": "Heures pleines été (€)",
              "hph": "Heures pleines hiver (€)",
              "hce": "Heures creuses été (€)",
              "hch": "Heures creuses hiver (€)"
            },
            "placeholder": {
              "surfaceArea": "Superficie du site en m²",
              "pointe": "Coût des heures de pointe",
              "hp": "Coût des heures pleines",
              "hc": "Coût des heures creuses",
              "hpe": "Coût des heures pleines d’été",
              "hph": "Coût des heures pleines d’hiver",
              "hce": "Coût des heures creuses d’été",
              "hch": "Coût des heures creuses d’hiver"
            }
          }
        },
        "siteSections": {
          "title": "Gestion des espaces",
          "subtitle": "Gérer les espaces de l’établissement {siteName}",
          "table": {
            "searchSection": "Rechercher un espace",
            "column": {
              "sectionId": "ID Espace",
              "name": "Nom",
              "surface": "Surface (m²)",
              "appliances": "Équipements",
              "viewAppliances": "Voir les équipements"
            }
          },
          "sectionAppliances": {
            "header": "Détail des équipements",
            "offlineTooltip": "Cet équipement n’a pas communiqué dans les dernières 24 heures"
          }
        },
        "siteTreeStructure": {
          "title": "Structure du site",
          "backToSitesList": "Retour à la liste des sites",
          "addSection": "Ajouter un espace",
          "select": "Sélectionner",
          "searchSection": "Rechercher un espace",
          "equipmentTypeFilter": "Type d'équipements",
          "searchEquipmentType": "Rechercher un équipement",
          "categoryFilter": "Catégorie",
          "searchCategory": "Rechercher une catégorie",
          "createCategory": "Créer une catégorie",
          "newCategory": "Nouvelle catégorie",
          "cancel": "Annuler",
          "bulkCategory": {
            "title": "Attribution de la catégorie",
            "cancelEdition": "Abandonner la sélection",
            "selectedCount": "0 espace sélectionné | 1 espace sélectionné | {count} espaces sélectionnés",
            "categoryPlaceholder": "Choisir une catégorie",
            "categoryHelp": "Choisissez d'abord une catégorie pour l'attribuer",
            "assignCategory": "Attribuer la catégorie",
            "removeCategory": "Retirer la catégorie",
            "selectAllVisible": "Tout sélectionner",
            "message": {
              "success": "La catégorie a bien été mise à jour sur les espaces sélectionnés.",
              "error": "Une erreur est survenue lors de la mise à jour des catégories des espaces sélectionnés."
            },
            "abandonSelection": {
              "title": "Abandonner la sélection",
              "message": "Vous êtes sur le point de perdre votre sélection",
              "continueEdition": "Continuer l'édition",
              "abandon": "Abandonner"
            }
          },
          "categoryCreation": {
            "message": {
              "success": "La catégorie a bien été créée.",
              "error": "Une erreur est survenue lors de la création de la catégorie."
            }
          },
          "categoryUpdate": {
            "message": {
              "success": "La catégorie a bien été mise à jour.",
              "error": "Une erreur est survenue lors de la mise à jour de la catégorie."
            }
          },
          "categoryDeletion": {
            "message": {
              "success": "La catégorie a bien été supprimée.",
              "error": "Une erreur est survenue lors de la suppression de la catégorie."
            }
          },
          "categoryAssignment": {
            "action": "Associer une catégorie",
            "message": {
              "success": "La catégorie a bien été associée à l'espace.",
              "removalSuccess": "La catégorie a bien été retirée de l'espace.",
              "error": "Une erreur est survenue lors de l'association de la catégorie."
            }
          },
          "categoryDrawer": {
            "manage": "Gérer les catégories",
            "title": "Gérer les catégories",
            "assign": "Associer",
            "delete": {
              "disabledTooltip": "Cette catégorie ne peut pas être supprimée car elle est utilisée par au moins un espace.",
              "title": "Supprimer “{categoryName}” ?",
              "message": "Cette action est définitive et irréversible.",
              "submit": "Supprimer définitivement"
            }
          },
          "activeFilters": "Filtres actifs :",
          "visibleSectionsCount": "Aucun espace visible | 1 espace visible | {count} espaces visibles",
          "creation": {
            "pendingPreviewName": "Nouvel espace",
            "button": "Ajouter un espace",
            "drawer": {
              "title": "Créer un espace",
              "in": "Dans"
            },
            "form": {
              "name": {
                "label": "Nom de l'espace",
                "placeholder": "Ex. Chambre 305"
              },
              "area": {
                "label": "Surface",
                "placeholder": "Ex. 12 m2"
              },
              "parentSection": "Espace parent",
              "category": {
                "label": "Catégorie",
                "none": "Aucun"
              },
              "root": "{siteName} (Racine du site)",
              "submitButton": "Créer l'espace",
              "message": {
                "success": "L'espace a bien été créé.",
                "error": "Une erreur est survenue lors de la création de l'espace."
              }
            }
          }
        },
        "sectionDetails": {
          "informations": "Informations",
          "name": "Nom de l'espace",
          "area": "Surface",
          "category": "Catégorie",
          "parentSection": "Espace parent",
          "deletion": {
            "deleteSection": "Supprimer l'espace",
            "cannotDeleteSectionExplanation": "\n              Cet espace ne peut pas être supprimé tant qu'il contient une programmation,\n              des sous-espaces, des équipements ou des médias associés.\n            ",
            "confirmation": {
              "title": "Supprimer “{sectionName}” ?",
              "submitText": "Supprimer définitivement"
            },
            "success": "L'espace a bien été supprimé.",
            "error": "Une erreur est survenue lors de la suppression de l'espace."
          },
          "edition": {
            "abandonChanges": {
              "abandon": "Abandonner",
              "continueEdition": "Continuer l'édition",
              "message": "Vous êtes sur le point d'abandonner les modifications effectuées sur l'espace",
              "title": "Abandonner les modifications"
            },
            "changesNotSaved": "Les modifications ne sont pas encore enregistrées",
            "editionMode": "Mode édition",
            "targetRoot": "L'espace sera déplacé à la racine du site",
            "unsavedChangesCount": "1 modification non sauvegardée | {count} modifications non sauvegardées",
            "message": {
              "success": "L'espace a bien été mis à jour.",
              "error": "Une erreur est survenue lors de la mise à jour de l'espace."
            }
          }
        },
        "sectionAppliances": {
          "applianceCount": "Aucun équipement | 1 équipement | {count} équipements",
          "title": "Équipements",
          "moveAppliances": "Déplacer des équipements",
          "seeAll": "Voir tous les équipements ({count})",
          "table": {
            "searchApplianceByNameOrId": "Rechercher par nom ou ID",
            "applianceType": "Type d'équipement",
            "applianceName": "Nom d'équipement",
            "applianceId": "Identifiant de l'équipement",
            "moveTo": "Déplacer vers..."
          }
        },
        "moveSiteAppliancesWizard": {
          "title": "Déplacer l'équipement vers... | Déplacer {count} équipements vers...",
          "subtitle": "Sélectionnez l'espace de destination",
          "message": "L'équipement doit être placé dans un espace sans enfants. | Les équipements doivent être placés dans un espace sans enfants.",
          "toMigrate": "À déplacer",
          "executeMigration": "Exécuter tous les déplacements",
          "success": "Les déplacements d'équipement ont bien été effectués.",
          "error": "Une erreur est survenue lors du déplacement d'équipement."
        },
        "selectParentSection": {
          "title": "Choisir un espace parent",
          "subtitle": "Sélectionnez l'espace de destination",
          "destination": "Destination",
          "parent": "Parent",
          "to": "Vers",
          "choose": "Choisir {sectionName}",
          "targetRoot": "L'espace sera créé à la racine du site"
        },
        "moveSection": {
          "message": {
            "success": "L'espace a bien été déplacé.",
            "error": "Une erreur est survenue lors du déplacement de l'espace."
          }
        }
      }
    },
    "veeValidate": {
      "code": "fr",
      "messages": {
        "_default": "Le champ est invalide",
        "alpha": "Le champ ne peut contenir que des lettres",
        "alpha_num": "Le champ ne peut contenir que des caractères alpha-numériques",
        "alpha_dash": "Le champ ne peut contenir que des caractères alpha-numériques, tirets ou soulignés",
        "alpha_spaces": "Le champ ne peut contenir que des lettres ou des espaces",
        "between": "Le champ doit être compris entre {min} et {max}",
        "confirmed": "Le champ ne correspond pas",
        "date": "Le champ doit être une date valide",
        "digits": "Le champ doit être un nombre entier de {length} chiffres",
        "dimensions": "Le champ doit avoir une taille de {width} pixels par {height} pixels",
        "email": "Le champ doit être une adresse e-mail valide",
        "not_one_of": "Le champ doit être une valeur valide",
        "ext": "Le champ doit être un fichier valide",
        "image": "Le champ doit être une image",
        "integer": "Le champ doit être un entier",
        "length": "Le champ doit contenir {length} caractères",
        "max_value": "Le champ doit avoir une valeur de {max} ou moins",
        "max": "Le champ ne peut pas contenir plus de {length} caractères",
        "mimes": "Le champ doit avoir un type MIME valide",
        "min_value": "Le champ doit avoir une valeur de {min} ou plus",
        "min": "Le champ doit contenir au minimum {length} caractères",
        "numeric": "Le champ ne peut contenir que des chiffres",
        "one_of": "Le champ doit être une valeur valide",
        "one_of_values": "Le champ doit être une valeur valide ({values})",
        "not_one_of_values": "Le champ ne doit pas être l'une des valeurs suivantes: {values}",
        "regex": "Le champ est invalide",
        "required_if": "Le champ est obligatoire lorsque {target} possède cette valeur",
        "required": "Le champ est obligatoire",
        "size": "Le champ doit avoir un poids inférieur à {size}KB",
        "phoneNumber": "Le champ doit être un numéro de téléphone valide",
        "url": "Le champ doit être un url valide",
        "password_complexity_requirement": "Votre mot de passe ne respecte pas tous les critères de sécurité.",
        "password_mismatch": "Les mots de passe saisis ne sont pas identiques. Veuillez vérifier et réessayer.",
        "section_name_already_used": "Un espace porte déjà ce nom. Modifiez-le pour continuer.",
        "errors": {
          "invalidType": "Le champ est obligatoire",
          "invalidTypeReceivedUndefined": "Le champ est obligatoire",
          "invalidString": {
            "email": "Le champ doit être un email valide"
          },
          "programming_range": {
            "min_duration": "Une programmation doit durer au moins 50 min"
          },
          "time": {
            "startNotPassed": "L'heure de début ne doit pas être dans le passé"
          },
          "tooSmall": {
            "number": {
              "inclusive": "Le champ doit valoir une valeur égale ou supérieure à {min}"
            },
            "string": {
              "inclusive": "Le champ doit contenir au minimum {min} caractères"
            }
          }
        }
      }
    },
    "wizard": {
      "piloting": {
        "temperature": "Température",
        "programmingDurationMode": {
          "duration": "Durée",
          "date-range": "Période"
        },
        "timezone": {
          "siteTimezoneInfo": "Le site sera piloté à l'heure {timezone}",
          "siteTimezoneWarning": "Il semblerait que vous ne soyez pas sur le même fuseau horraire ({clientTimezone}) que le site que vous souhaitez piloter ({siteTimezone})"
        },
        "subtitle": {
          "create": "Appliquer un mode à une sélection d'espaces",
          "edit": "Éditer un mode"
        },
        "planMode": "Planifier un mode",
        "availableModes": "Modes disponibles",
        "modeHelpText": "La consigne sera appliquée à votre sélection d'espaces",
        "duration": "Durée",
        "durationHelpText": "La consigne sera appliquée pour une durée précise",
        "dateRange": "Période",
        "dateRangeHelpText": "La consigne sera appliquée pour une période entre deux dates",
        "filterSectionsPlaceholder": "Rechercher un espace",
        "messages": {
          "apply": {
            "success": "Le pilotage a été appliqué à la sélection d'espaces.",
            "error": "Une erreur est survenue lors de l'application du pilotage à certains espaces. Veuillez réessayer ultérieurement."
          },
          "edit": {
            "success": "Le pilotage a été mis à jour.",
            "error": "Une erreur est survenue lors de l'édition du pilotage. Veuillez réessayer ultérieurement."
          }
        }
      }
    }
  },
  "en": {
    "commonFrontend": {
      "misc": {
        "noResult": "No result",
        "other": "Other"
      },
      "site-tree-structure": {
        "title": "Site structure",
        "searchSection": "Search section"
      },
      "site-sections-tree": {
        "appliance-count": "No appliance | 1 appliance | {count} appliances",
        "section-appliances": {
          "title": "Appliances",
          "move-appliances": "Move appliances",
          "see-all": "See all appliances ({count})"
        }
      },
      "applianceCategory": {
        "HEATER": "Heating",
        "AC_UNIT_NON_INFRARED": "Air conditioning",
        "WATER_HEATER": "Water heater"
      }
    },
    "authentication": {
      "title": {
        "welcome": "Welcome!",
        "subtitle": "Please enter your email address and password."
      },
      "email": {
        "label": "Email",
        "placeholder": "Your email"
      },
      "password": {
        "label": "Password",
        "placeholder": "Your password"
      },
      "login": "Login",
      "error": "Incorrect login, please try again.",
      "forgotPassword": {
        "link": "Forgot password?",
        "title": "Password recovery",
        "subtitle": "Enter the e-mail address you use for enterprise.voltalis.com",
        "label": "Your corporate e-mail address",
        "placeholder": "Enter your e-mail address",
        "success": "You will receive an e-mail to retrieve your password"
      },
      "passwordRecovery": {
        "newPassword": "New password",
        "subtitle": "Create a new secured password to protect your account.",
        "message": "For added security, avoid using personal information or passwords that have already been used.",
        "success": "Your password has been reset successfully."
      },
      "activation": {
        "title": "Welcome to your space!",
        "subtitle": "Before you start, you'll need to create your password to access your account.",
        "message": "Use a unique and complex password.",
        "createPassword": "Create my password"
      }
    },
    "components": {
      "contact-voltalis-dialog": {
        "title": "Contact Voltalis",
        "subtitle": "For any question, feel free to contact us",
        "form": {
          "site-id": {
            "label": "Site"
          }
        }
      },
      "programmingGantt": {
        "messages": {
          "deleteSchedule": {
            "success": "Schedule has been deleted",
            "error": "Error while deleting schedule, please try again later..."
          }
        },
        "siteHasNoSection": {
          "title": "No section for this appliance type",
          "subtitle": "The site has no section with the selected appliance type that can be controlled"
        }
      },
      "layout": {
        "sideMenu": {
          "control": "Control",
          "piloting": "Manual setting",
          "programming": "Programs",
          "data": "Data",
          "dashboard": "Dashboard",
          "consumptionMonitoring": "Consumption monitoring",
          "tools": "Tools",
          "sitesManagement": "Site management | Sites management",
          "newSitesManagement": "Site management | Sites management",
          "settings": "Settings",
          "contact": "Contact Voltalis",
          "logout": "Logout",
          "dialog": {
            "logoutConfirmation": "Are you sure you want to disconnect?"
          }
        },
        "breadcrumb": {
          "consumption-monitoring": "Consumption monitoring",
          "dashboard-monosite": "Site consumption",
          "dashboard-view": "Dashboard",
          "piloting": "Manual setting",
          "planning": "Planning",
          "programming": "Programs",
          "programming-creation": "New program",
          "new-programming-creation": "New program",
          "programming-list": "Schedules list",
          "new-programming-list": "Schedules list",
          "programming-details": "Schedule details",
          "new-programming-details": "Schedule details",
          "section-management": "Legacy Sites management",
          "new-section-management": "Site management",
          "site-sections": "Sections list",
          "site-sections-tree": "Sections tree",
          "activation": "Activation",
          "site-consumption-monitoring": "Site consumption",
          "home": "Home",
          "login": "Login",
          "password-recovery": "Password recovery"
        },
        "error404": {
          "title": "Page not found",
          "subtitle": "The page you are trying to access cannot be found"
        }
      },
      "passwordCreation": {
        "newPassword": "New password",
        "passwordConfirmation": "Password confirmation",
        "passwordShouldContain": "Your password should contain",
        "atLeast10Char": "At least 10 characters",
        "oneUppercase": "One uppercase letter",
        "oneLowercase": "One lowercase letter",
        "oneNumber": "One number",
        "oneSpecialCharacter": "{'One special character (e.g.: @, #, !)'}",
        "success": "Your password has been successfully reset"
      },
      "selectProgram": {
        "noResult": "No applicable program."
      },
      "programApplianceStepperCard": {
        "disabledApplianceTooltip": "Setup current appliance before getting to the next"
      }
    },
    "control": {
      "piloting": {
        "title": "Manual setting",
        "siteSectionsTree": "Site tree structure",
        "subtitle": "Manage sites by section",
        "zoomIn": "Zoom in",
        "zoomOut": "Zoom out",
        "siteProgramingSuspendedWarning": "Voltalis solution suspended",
        "siteHasSuspendedProgramingWarning": "Your site is no longer under supervision",
        "siteHasSuspendedProgramingWarningDetails": "Your site is no longer under Voltalis supervision, you can still manage your equipement manually",
        "planning": {
          "title": "Piloting planning",
          "subtitle": "Select sections, then apply a program.",
          "accessLegacyPiloting": "Access legacy piloting",
          "defaultProgram": "Default program",
          "form": {
            "title": {
              "create": "Apply program",
              "edit": "Edit program"
            },
            "countSelectedSections": "1 selected controllable section | {count} selected controllable sections",
            "startDate": "Start date",
            "startTime": "Start time",
            "endDate": "End date",
            "endTime": "End time",
            "indefinitePeriod": "Indefinite period"
          },
          "createProgrammingRange": {
            "success": "The program has been planned successfully.",
            "error": "An error occurred while creating the program planning."
          },
          "updateProgrammingRange": {
            "success": "The program planning has been updated successfully.",
            "error": "An error occurred while updating the program planning."
          },
          "deleteProgrammingRange": {
            "title": "Delete this programming?",
            "subtitle": "This action is permanent. The programming will be permanently deleted and will no longer apply to this section.",
            "success": "The programming has been deleted successfully.",
            "error": "An error occurred while deleting the programming."
          },
          "programmingRangeActions": "Actions for {name}"
        }
      },
      "programming": {
        "title": "Programs",
        "subtitle": "Manage site programs",
        "programList": "Program list",
        "searchProgram": "Search program",
        "createProgram": "Create program",
        "newProgram": "New program",
        "defaultProgram": "Default program",
        "countPrograms": "No program | 1 program | {count} programs",
        "customProgramsCount": "No custom program | 1 custom program | {count} custom programs",
        "activation": {
          "error": "An error occured while activating a program."
        },
        "creation": {
          "title": "Create a new program",
          "subtitle": "Setting up a new program",
          "programName": "Program name",
          "error": "An error occurred while creating a new program."
        },
        "clone": {
          "action": "Clone"
        },
        "copyToOtherSite": {
          "action": "Copy to another site",
          "title": "Copy {name} to another site",
          "subtitle": "Copy an existing program to a different site",
          "targetSite": "Target site",
          "success": "The program has been successfully duplicated.",
          "error": "An error occurred while duplicating a program."
        },
        "renaming": {
          "title": "Rename a program",
          "error": "An error occurred while renaming a program."
        },
        "deletion": {
          "title": "Delete program",
          "subtitle": "You are about to delete the program {name}.",
          "success": "The program has been deleted.",
          "error": "An error occurred while deleting the program."
        },
        "details": {
          "title": "Scheduling {name}",
          "subtitle": "Configuration of a program affecting {siteName}",
          "businessDays": "Working days",
          "weekend": "Weekend",
          "dayDuplication": {
            "title": "Duplicate {day}",
            "subtitle": "Copy this day's schedule to:",
            "allDays": "All days",
            "workingDays": "Working days",
            "weekend": "Weekend"
          },
          "dayOptions": "Options for {day}",
          "saveProgram": "Save program",
          "editProgram": "Edit program",
          "loadError": "The program could not be loaded.",
          "retry": "Retry",
          "identity": {
            "creationSubtitle": "Configuration of a new program affecting the site",
            "detailsSubtitle": "Configuration of the program affecting the site",
            "title": "Identity",
            "programName": "Program name",
            "programNamePlaceholder": "Program name",
            "programNameRequired": "The program name is required.",
            "programColor": "Program color"
          },
          "appliances": {
            "title": "Appliances",
            "configure": "Configure appliance",
            "configureNext": "Configure next appliance",
            "loadError": "The site's appliances could not be loaded. Program creation is unavailable.",
            "validateProgram": "Validate program"
          },
          "quickConfigurations": {
            "title": "Quick configuration",
            "subtitle": "Apply to appliance:",
            "weekendOff": "Off on weekends",
            "everyDayOn": "On every day",
            "nightOff": "Off at night",
            "weekdaysEco": "Eco on week days",
            "everyDayComfort": "Comfort every day",
            "nightFrost": "Frost at night"
          },
          "cancel": "Cancel",
          "edit": {
            "success": "The program has been successfully saved.",
            "error": "An error has occurred while recording the program."
          },
          "unsavedChanges": {
            "title": "Unsaved changes",
            "message": "Your changes will be lost if you leave without saving them.",
            "discard": "Discard changes",
            "continueEditing": "Continue editing"
          }
        },
        "range": {
          "addition": "Add a time window",
          "edition": "Edit a time window",
          "subtitle": "Program configuration",
          "deletion": {
            "title": "Delete program",
            "confirmationMessage": "Are you sure you want to delete the {mode} program from {day} ({startTime} to {endTime})?"
          },
          "error": {
            "cannotDeleteLastRange": "Unable to delete the only program on {day}",
            "minThreshold": "A program should last at least 30 minutes",
            "endInferiorToStart": "End time cannot be less than start time",
            "emptyRange": "A day cannot include any empty slot",
            "mandatoryMode": "Please select a mode"
          },
          "applianceType": "Appliance type",
          "availableInstructions": "Available instructions",
          "startTime": "Start",
          "endTime": "End",
          "mode": "Mode",
          "temperature": "Temperature (°C)",
          "multipleApplications": "Multiple applications",
          "applyOnBusinessDays": "Apply on business days",
          "applyOnWeekEnd": "Apply on weekend",
          "temperatureMode": "Temperature"
        }
      }
    },
    "data": {
      "dashboard": {
        "title": "Dashboard",
        "emptySitePerimeter": "You have no access to any site",
        "subtitle": {
          "MONOSITE": "Section cost and consumption data from {fromDate} to {toDate}",
          "MULTISITE": "Site cost and consumption data from {fromDate} to {toDate}"
        },
        "insights": {
          "title": "Insights",
          "totalConsumption": {
            "title": {
              "MONOSITE": "Site Global Cons.",
              "MULTISITE": "Sites Global Cons."
            },
            "tooltip": {
              "MONOSITE": "Consumption data provided by ENEDIS, which aggregates the power consumption of your entire site.\n\n            It is aggregated over the indicated period.",
              "MULTISITE": "Consumption data provided by ENEDIS, which aggregates the power consumption of all your sites.\n\n            It is aggregated over the indicated period."
            },
            "missingDsoSubscription": "Missing provider data",
            "subtitle": {
              "MONOSITE": "Over the last 30 days",
              "MULTISITE": "An average of {average} per site"
            }
          },
          "equipmentConsumption": {
            "title": "Devices cons.",
            "tooltip": {
              "MONOSITE": "Cumulative power consumption of Voltalis smart switches on site, over the indicated period.\n\n            This data is supplied directly by Voltalis smart switches.",
              "MULTISITE": "Consumption data collected by appliances installed by Voltalis across all your sites.\n\n            This data is aggregated over the indicated period."
            },
            "subtitle": "{percent}% of global consumption"
          },
          "m2Consumption": {
            "title": "M² cons.",
            "tooltip": {
              "DSO": "This is the division of {sitesConsumption} and the area declared in the {sitesManagementTab} tab.",
              "DEVICES": "This is the division of {sitesConsumption} and the area declared in the {sitesManagementTab} tab.",
              "fallback": "This is the division of consumption and the area declared in the {sitesManagementTab} tab."
            },
            "subtitle": "Average {amount}€/m2",
            "missingSurfaceArea": "Required action · Missing site surface area | Required action · Missing sites surface area"
          },
          "consumptionEvolution": {
            "title": {
              "DSO": "Global site cons. evolution | Global sites cons. evolution",
              "DEVICES": "Devices cons. evolution",
              "fallback": "Consumption evolution"
            },
            "tooltip": {
              "DSO": "This is the variation of {sitesConsumption} between year Y and year Y-1 over the indicated period.",
              "DEVICES": "This is the variation in devices consumption on your sites in year N compared to year N-1 over the indicated period.",
              "fallback": "This is the variation of consumption between year Y and year Y-1 over the indicated period."
            },
            "subtitle": "Compared to the previous period",
            "highVariation": {
              "warning": "High variation",
              "details": "A large variation may simply indicate that your equipment fleet was not yet fully deployed last year."
            }
          },
          "totalCost": {
            "title": {
              "DSO": "Estimated global tarif",
              "DEVICES": "Estimated devices tarif",
              "fallback": "Estimated cost"
            },
            "tooltip": "This is the power tariffs declared in the {sitesManagementTab} tab multiplied by the {sitesConsumption}.\n\n            ⚠️ This cost is an estimate, it does not take into account taxes or your contract subscription fee. For more accurate data, please contact your energy supplier.",
            "subtitle": "Including {amount}€ related to devices"
          },
          "ranking": {
            "title": {
              "MONOSITE": "Podium of the most energy-efficient sections",
              "MULTISITE": "Podium of the most energy-efficient sites"
            },
            "tooltip": {
              "MONOSITE": "Sections with the lowest power consumption over the indicated period are highlighted on this graph.\n\n            The power consumption of a section is the cumulative consumption of all equipment in the section installed with Voltalis smart switches.",
              "MULTISITE": "The sites with the lowest power consumption over the indicated period are highlighted on this graph.\n\n            The power consumption of a site is the cumulative consumption of all associated meter points (MPAN). This data is supplied daily by Enedis."
            }
          }
        },
        "consumptionChart": {
          "title": "Consumption",
          "tooltip": {
            "MONOSITE": "This graph shows your {sitesConsumption} as well as its {equipmentConsumption} on a daily basis.\n\n          This data is aggregated over the indicated period.",
            "MULTISITE": "This graph shows your {sitesConsumption} as well as your sites {equipmentConsumption}.\n\n          This data is aggregated over the indicated period.",
            "estimated": {
              "MONOSITE": "This graph shows your estimated {sitesConsumption} as well as its {equipmentConsumption} on a daily basis.\n\n            This data is aggregated over the indicated period.\n\n            While waiting for data from the distribution system operator, Voltalis calculates an estimate of your consumption data.",
              "MULTISITE": "This graph shows your estimated {sitesConsumption} as well as your sites {equipmentConsumption}.\n\n            This data is aggregated over the indicated period.\n\n            While waiting for data from the distribution system operator, Voltalis calculates an estimate of your consumption data."
            }
          },
          "totalConsumption": {
            "name": "Total consumption",
            "description": {
              "MONOSITE": "The site's power consumption over the indicated period. This data is supplied by Enedis.",
              "MULTISITE": "The consumption of sites within the user's perimeter over the indicated period. This data is supplied by Enedis"
            }
          },
          "applianceConsumption": {
            "name": "Devices consumption",
            "description": {
              "MONOSITE": "Cumulative power consumption of Voltalis smart switches on site, over the indicated period.",
              "MULTISITE": "Cumulative power consumption of equipment on sites with Voltalis smart switchee, over the indicated period."
            }
          }
        },
        "areaConsumptionChart": {
          "title": "Consumption per m²",
          "tooltip": {
            "MONOSITE": "This is the total consumption of Voltalis appliances for each section divided by its surface area, as indicated in the {sitesManagementTab} tab.\n\n          This data is aggregated over the indicated period.",
            "MULTISITE": "This is the total consumption of each site divided by its total area as entered in the {sitesManagementTab} tab.\n\n          This data is aggregated over the indicated period."
          },
          "legend": {
            "MONOSITE": "Section consumption per m²",
            "MULTISITE": "Site consumption per m²"
          },
          "description": {
            "MONOSITE": "Cumulative power consumption per m² over the indicated period for each section",
            "MULTISITE": "Cumulative power consumption per m² over the indicated period for each site"
          }
        },
        "consumptionComparisonChart": {
          "title": "Consumption evolution",
          "tooltip": {
            "DSO": "This graph shows the change in {sitesConsumption} in year N compared to year N-1.",
            "DEVICES": "This graph shows the change in {equipmentConsumption} in year N compared to year N-1.",
            "fallback": "This graph shows the change in consumption in year N compared to year N-1."
          },
          "lastPeriod": {
            "description": {
              "MONOSITE": "Section consumption over the indicated period of the previous year.",
              "MULTISITE": "Site's consumption provided by Enedis over the indicated period of the previous year."
            }
          },
          "currentPeriod": {
            "description": {
              "MONOSITE": "Section consumption over the indicated period of the current year.",
              "MULTISITE": "Site's consumption provided by Enedis over the indicated period of the current year."
            }
          }
        },
        "deviceConsumptionDistribution": {
          "title": "Device consumption distribution",
          "subtitle": "Based on {amount} Voltalis devices",
          "deviceCategory": {
            "HEATER": "Heater",
            "WATER_HEATER": "Water heater",
            "AIR_CONDITIONING_COOLING": "Air conditioning",
            "HEAT_PUMP": "Heat pump",
            "OTHER": "Other"
          },
          "tooltip": "This graph shows the distribution of {equipmentConsumption} installed by Voltalis.\n\n          Equipment not installed by Voltalis is grouped under the category “Other.”\n\n          This data is aggregated over the indicated period.",
          "description": {
            "MONOSITE": "Cumulative power consumption distribution among installed appliance types on the site, over the indicated period",
            "MULTISITE": "Cumulative power consumption distribution among installed appliance types on the sites, over the indicated period"
          }
        },
        "topFlops": {
          "highestConsumption": {
            "MONOSITE": "Highest power consuming sections",
            "MULTISITE": "Highest power consuming sites"
          },
          "highestPositiveEvolution": {
            "MONOSITE": "Sections with the highest increase in consumption (Y/Y)",
            "MULTISITE": "Sites with the highest increase in consumption (Y/Y)"
          },
          "highestNegativeEvolution": {
            "MONOSITE": "Sections with the sharpest drop in consumption (Y/Y)",
            "MULTISITE": "Sites with the sharpest drop in consumption (Y/Y)"
          }
        },
        "consumptionHeatmap": {
          "title": {
            "DSO": "Site global consumption (12 months, day by day) | Sites global consumption (12 months, day by day)",
            "DEVICES": "Site devices consumption (12 months, day by day) | Sites devices consumption (12 months, day by day)",
            "fallback": "Consumption (12 months, day by day)"
          }
        },
        "messages": {
          "noData": {
            "MONOSITE": {
              "accessDataMessage": "Some consumption data of your {action} is not available. Please contact a Voltalis advisor for more information.",
              "action": "conso.totale"
            },
            "MULTISITE": {
              "accessDataMessage": "Some consumption data of your {action} is not available. Please contact a Voltalis advisor for more information.",
              "action": "sites cons."
            }
          },
          "missingConsents": {
            "contactVoltalis": "To access your consumption data, please {contactLink}",
            "contactLink": "contact Voltalis",
            "prefilledDescription": "I would like to access my consumption data"
          }
        },
        "missingInfos": {
          "title": "Missing data",
          "subtitle": {
            "MONOSITE": "The following data is missing. Please go to Site Management to complete them.",
            "MULTISITE": "The following data is missing. Please go to Sites Management to complete them."
          },
          "MONOSITE": {
            "goToSiteManagement": "Go to site management",
            "missingPrice": "Missing consumption cost",
            "missingSiteArea": "Missing site surface area",
            "missingSiteSectionArea": "Missing one or more sections surface areas"
          },
          "MULTISITE": {
            "missingSurfaceArea": "Missing surface area",
            "missingConsumptionCost": "Missing consumption cost"
          }
        },
        "missingDsoSubscriptionDialog": {
          "title": "Absence of global consumption data",
          "subtitle": "The energy supplier's data is not yet available.",
          "content": {
            "MONOSITE": "The global consumption for the site is not yet available. This is because data from the energy supplier can only be displayed if permission has been given to share this information.\n\n            To access the global consumption for your site, please contact Voltalis to activate the sharing of your supplier data.",
            "MULTISITE": "The global consumption for your sites is not yet available. This is because data from the energy supplier can only be displayed if permission has been given to share this information.\n\n            To access the overall consumption for your sites, please contact Voltalis to activate the sharing of your supplier data."
          }
        },
        "missingSurfaceArea": {
          "title": "Missing surface area",
          "subtitle": {
            "partial": {
              "MONOSITE": "The consumption per m² cannot be calculated because the area of some sections has not been specified. Please specify them in the {sitesManagementTab} tab.",
              "MULTISITE": "The consumption per m² cannot be calculated because the area of your sites has not been specified."
            },
            "total": {
              "MONOSITE": "The consumption per m² cannot be calculated because no surface area has been specified for your site sections. Please specify them in the {sitesManagementTab} tab.",
              "MULTISITE": "The consumption per m² cannot be calculated because no surface area has been specified for your sites."
            }
          }
        },
        "noDataChartMessage": {
          "title": "Required informations to display this chart",
          "noInstalledDevices": "No {installedDevices}. Unable to display information from this chart.",
          "installedDevices": "device is currently installed"
        },
        "selectPerimeter": {
          "title": "Perimeter selection",
          "submit": "Submit selection",
          "selected": "Selected perimeter"
        },
        "error": "An error has occured while trying to retrieve the site consumption data. Please try again."
      },
      "consumptionMonitoring": {
        "subtitle": "Monitor sites consumption from {fromDay} to {toDay}",
        "sitesDataTable": {
          "header": {
            "siteName": "Site name",
            "sections": "Sections",
            "appliances": "Devices",
            "consumption": {
              "DSO": "Global consumption",
              "DEVICES": "Device consumption",
              "fallback": "Consumption"
            },
            "subtitle": {
              "bySite": "By site",
              "last30days": "30 last days"
            }
          }
        },
        "siteMonitoring": {
          "title": "Site consumption",
          "backToSitesList": "Back to sites list",
          "sectionPerimeter": {
            "selectPerimeter": "Select section perimeter",
            "multipleSectionSelection": "Section selection"
          },
          "tabs": {
            "temporalConsumptionChart": "Global consumption",
            "consumptionComparisonChart": "Consumption evolution",
            "areaConsumptionChart": "Consumption per m²",
            "calendarHeatmapChart": "Heatmap"
          }
        }
      }
    },
    "global": {
      "locale": {
        "fr": "French",
        "en": "English"
      },
      "weekDays": {
        "1": "Monday",
        "2": "Tuesday",
        "3": "Wednesday",
        "4": "Thursday",
        "5": "Friday",
        "6": "Saturday",
        "7": "Sunday"
      },
      "units": {
        "temporal": {
          "SECOND": "Second | Seconds | { count } Seconds",
          "MINUTE": "Minute | Minutes | { count } Minutes",
          "HOUR": "Hour | Hours | { count } Hours",
          "DAY": "Day | Days | { count } Days",
          "WEEK": "Week | Weeks | { count } Weeks",
          "MONTH": "Month | Months | { count } Months",
          "QUARTER": "Quarter | Quarters | { count } Quarters",
          "YEAR": "Year | Years | { count } Years"
        },
        "dateScaling": {
          "shortWeek": "W{number}",
          "shortQuarter": "Q{number}"
        },
        "Wh": "{value}{prefix}Wh",
        "CELSIUS": "{value}°C",
        "€": "€{value}",
        "%": "{value}%",
        "kg": "{value}kg",
        "m²": "{value}m²"
      },
      "site": "site",
      "allSites": "All sites",
      "searchSite": "Search site",
      "section": "section",
      "consumption": "Consumption",
      "count": {
        "sites": "No site | 1 site | {count} sites",
        "appliances": "No appliance | 1 appliance | {count} appliances",
        "section": "No section | 1 section | {count} sections"
      },
      "noData": "No data",
      "missingData": "Missing data",
      "invalidForm": "Invalid form, please ensure that all fields are valid.",
      "misc": {
        "add": "Add",
        "apply": "Apply",
        "back": "Back",
        "cancel": "Cancel",
        "change": "Change",
        "clearAll": "Clear all",
        "close": "Close",
        "confirm": "Confirm",
        "copied": "Copied",
        "copy": "Copy",
        "copyOf": "Copy of {name}",
        "create": "Create",
        "dateFrom": "From",
        "dateTo": "To",
        "delete": "Delete",
        "deletePermanently": "Delete permanently",
        "details": "Details",
        "duration": "Duration",
        "edit": "Edit",
        "later": "Later",
        "next": "Next",
        "no": "No",
        "noResult": "No result",
        "noResultSearchHelpText": "\n        We couldn't find any results matching your search.\n        Please check your criteria or adjust your filters to explore more options\n      ",
        "optional": "optional",
        "other": "Other",
        "paste": "Paste",
        "permanentAction": "This action is final and irreversible.",
        "pilot": "Pilot",
        "previous": "Previous",
        "program": "Program",
        "refresh": "Refresh",
        "rename": "Rename",
        "save": "Save",
        "search": "Search",
        "selectAll": "Select all",
        "send": "Send",
        "sort": "Sort",
        "submit": "Submit",
        "today": "Today",
        "unselectAll": "Unselect all",
        "yes": "Yes"
      },
      "program": {
        "metaMode": {
          "CONFORT": "Comfort",
          "ECO": "Eco",
          "HORS_GEL": "Frost",
          "PROGRAMMING": "Program",
          "ON": "On",
          "TEMPERATURE": "Temp.",
          "OFF": "Off",
          "OCCUPIED": "Occupied",
          "AVAILABLE": "Available",
          "equivalent": {
            "CONFORT": "Equivalent to 20°C",
            "ECO": "Equivalent to 17°C",
            "HORS_GEL": "Equivalent to 7°C"
          }
        }
      },
      "applianceCategory": {
        "HEATER": "Heater",
        "AC_UNIT_NON_INFRARED": "Air conditioning units",
        "AIR_HANDLING_UNIT": "Air handling unit",
        "BOILER": "Boiler",
        "CHARGING_STATION": "Charging stations (EV)",
        "CHILLER": "Chiller",
        "CHILLER_FOOD_GRADE": "Food-grade chiller",
        "GENERATOR_SET": "Generator set",
        "HEATER_STORAGE": "Storage Heater",
        "HEATER_UNIT": "Unit heater",
        "HEATING_FLOOR": "Underfloor heating",
        "HEAT_PUMP": "Heat pump",
        "HEAT_PUMP_DHW": "Heat pump (DHW)",
        "HEAT_PUMP_WITH_TEMPERATURE": "Heat pump (temp. sensor)",
        "POOL_HEATER": "Pool heater",
        "PUMP_MOTOR": "Pump motor",
        "RADIANT_CEILING_PANEL": "Radiant ceiling panel",
        "WATER_HEATER": "Water heater",
        "BOOKABLE_SPACE": "Bookable space"
      },
      "filters": {
        "hide": "Hide filters",
        "show": "Display filters"
      },
      "applianceType": {
        "appliances": {
          "heater": "Heater",
          "underfloorHeating": "Heating floor",
          "waterHeater": "Water heater"
        }
      },
      "roomType": {
        "bathroom": "Bathroom",
        "bedroom": "Bedroom",
        "entrance": "Entrance",
        "hallway": "Hallway",
        "kitchen": "Kitchen",
        "lounge": "Living room",
        "office": "Office",
        "other": "Other"
      },
      "tarifType": {
        "offPeakHours": "OPT",
        "peakHours": "PT"
      },
      "fullTarifType": {
        "offPeakHours": "Off peak time",
        "peakHours": "Peak time"
      }
    },
    "error": {
      "default": "An error has occured, please try again.",
      "form": "Form errors: {errors}",
      "DUPLICATE_PROGRAM_NAME_FOR_SAME_SITE": "\n      This program name already exists in the target site. Please enter a different name.\n    ",
      "ACTIVE_PROGRAMS_CANNOT_BE_DELETED": "Unable to delete an active program.",
      "USER_ACCOUNT_ALREADY_ACTIVATED": "Error: Your password has already been defined. Please login.",
      "ACTIVATION_CODE_EXPIRED": "Error: The link to set your password has expired. Please contact us.",
      "RECOVERY_CODE_EXPIRED": "Error: The link to set your password has expired. Please contact us.",
      "EMAIL_ADDRESS_INVALID_FORMAT": "Invalid email address",
      "PHONE_NUMBER_INVALID_FORMAT": "Invalid phone number",
      "INTEGER_INVALID_VALUE": "Invalid number value",
      "INTEGER_NEGATIVE": "Value cannot be negative",
      "INVALID_VALUE": "Invalid value",
      "IS_BLANK": "Value cannot be blank",
      "IS_EMPTY": "Value cannot be empty",
      "NOT_STRONG_ENOUGH_PASSWORD": "Password is not secure enough",
      "STRING_MAX_SIZE_EXCEEDED": "Value is too long",
      "STRING_MIN_SIZE_NOT_REACHED": "Value is too short",
      "STRING_WRONG_FIXED_SIZE": "Invalid value length",
      "UNEXPECTED_VALUE": "Unexpected value",
      "WRONG_STRING_CODE_FORMAT": "Invalid code format",
      "WRONG_STRING_NAME_FORMAT": "Invalid name format",
      "WRONG_STRING_RELAXED_NAME_FORMAT": "Invalid string format",
      "SITE_SECTION_ALREADY_EXISTS_WITH_SAME_NAME": "A section with this name already exists.",
      "SITE_SECTION_CATEGORY_NAME_EXISTS_ON_SITE": "A category with this name already exists on this site."
    },
    "tools": {
      "siteManagement": {
        "title": "Sites management",
        "subtitle": "Manage sites",
        "siteDetails": {
          "surfaceArea": "Surface area (m²)",
          "kWhCost": "KWh cost (€)",
          "edition": {
            "title": "Site edition",
            "editionMode": "Edition mode",
            "changesNotSavedYet": "Changes are not saved yet",
            "informations": "Informations",
            "siteName": "Site name",
            "label": {
              "pointe": "Apex time (€)",
              "hp": "Peak time (€)",
              "hc": "Off-peak time (€)",
              "hpe": "Summer peak time (€)",
              "hph": "Winter peak time (€)",
              "hce": "Summer off-peak time (€)",
              "hch": "Winter off-peak time (€)"
            },
            "placeholder": {
              "surfaceArea": "Site surface area in m²",
              "pointe": "Apex time cost",
              "hp": "Peak time cost",
              "hc": "Off-peak time cost",
              "hpe": "Summer peak time cost",
              "hph": "Winter peak time cost",
              "hce": "Summer off-peak time cost",
              "hch": "Winter off-peak time cost"
            }
          }
        },
        "siteSections": {
          "title": "Section management",
          "subtitle": "Manage site {siteName} sections",
          "table": {
            "searchSection": "Search section",
            "column": {
              "sectionId": "Section ID",
              "name": "Name",
              "surface": "Surface (m²)",
              "appliances": "Appliances",
              "viewAppliances": "View appliances"
            }
          },
          "sectionAppliances": {
            "header": "Appliance details",
            "offlineTooltip": "This equipment has not communicated in the last 24 hours"
          }
        },
        "siteTreeStructure": {
          "title": "Site tree structure",
          "backToSitesList": "Back to sites list",
          "addSection": "Add section",
          "select": "Select",
          "searchSection": "Search section",
          "equipmentTypeFilter": "Appliance type",
          "searchEquipmentType": "Search appliance",
          "categoryFilter": "Category",
          "searchCategory": "Search category",
          "createCategory": "Create category",
          "newCategory": "New category",
          "cancel": "Cancel",
          "bulkCategory": {
            "title": "Category assignment",
            "cancelEdition": "Abandon selection",
            "selectedCount": "0 selected sections | 1 selected section | {count} selected sections",
            "categoryPlaceholder": "Choose a category",
            "categoryHelp": "Choose a category first to assign it",
            "assignCategory": "Assign category",
            "removeCategory": "Remove category",
            "selectAllVisible": "Select all",
            "message": {
              "success": "The category has been updated on the selected sections.",
              "error": "An error occurred while trying to update the categories of the selected sections."
            },
            "abandonSelection": {
              "title": "Abandon selection",
              "message": "You are about to lose your selection",
              "continueEdition": "Continue editing",
              "abandon": "Abandon"
            }
          },
          "categoryCreation": {
            "message": {
              "success": "Category has been successfully created.",
              "error": "An error occurred while trying to create the category."
            }
          },
          "categoryUpdate": {
            "message": {
              "success": "Category has been successfully updated.",
              "error": "An error occurred while trying to update the category."
            }
          },
          "categoryDeletion": {
            "message": {
              "success": "Category has been successfully deleted.",
              "error": "An error occurred while trying to delete the category."
            }
          },
          "categoryAssignment": {
            "action": "Assign category",
            "message": {
              "success": "Category has been successfully assigned to the section.",
              "removalSuccess": "Category has been successfully removed from the section.",
              "error": "An error occurred while trying to assign the category."
            }
          },
          "categoryDrawer": {
            "manage": "Manage categories",
            "title": "Manage categories",
            "assign": "Assign",
            "delete": {
              "disabledTooltip": "This category cannot be deleted because it is used by at least one section.",
              "title": "Delete ‘{categoryName}’?",
              "message": "This action is final and cannot be undone.",
              "submit": "Delete permanently"
            }
          },
          "activeFilters": "Active filters:",
          "visibleSectionsCount": "No visible section | 1 visible section | {count} visible sections",
          "creation": {
            "pendingPreviewName": "New section",
            "button": "Add section",
            "drawer": {
              "title": "Create a new section",
              "in": "In"
            },
            "form": {
              "name": {
                "label": "Name",
                "placeholder": "E.g. Chamber 305"
              },
              "area": {
                "label": "Area (m2)",
                "placeholder": "E.g. 12"
              },
              "parentSection": "Parent section",
              "category": {
                "label": "Category",
                "none": "None"
              },
              "root": "{siteName} (Site root)",
              "submitButton": "Create section",
              "message": {
                "success": "Section has been successfully created.",
                "error": "An error occurred while trying to create the section."
              }
            }
          }
        },
        "sectionDetails": {
          "informations": "Informations",
          "name": "Section name",
          "area": "Area",
          "category": "Category",
          "parentSection": "Parent section",
          "deletion": {
            "deleteSection": "Delete section",
            "cannotDeleteSectionExplanation": "\n              This section cannot be deleted while it contains programming, sub-sections,\n              appliances, or associated media.\n            ",
            "confirmation": {
              "title": "Delete ‘{sectionName}’?",
              "submitText": "Delete permanently"
            },
            "success": "Section has been deleted successfully.",
            "error": "An error occurred while trying to delete the section."
          },
          "edition": {
            "abandonChanges": {
              "abandon": "Abandon",
              "continueEdition": "Continue editing",
              "message": "You are about to abandon the changes made to the section",
              "title": "Abandon changes"
            },
            "changesNotSaved": "Changes are not saved yet",
            "editionMode": "Edit mode",
            "targetRoot": "The section will be moved to the site root",
            "unsavedChangesCount": "1 unsaved change | {count} unsaved changes",
            "message": {
              "success": "Section has been updated successfully.",
              "error": "An error has occurred while trying to udate the section."
            }
          }
        },
        "sectionAppliances": {
          "applianceCount": "No appliances | 1 appliance | {count} appliances",
          "title": "Appliances",
          "moveAppliances": "Move appliances",
          "seeAll": "See all appliances ({count})",
          "table": {
            "searchApplianceByNameOrId": "Search by name or ID",
            "applianceType": "Appliance type",
            "applianceName": "Appliance name",
            "applianceId": "Appliance ID",
            "moveTo": "Move to..."
          }
        },
        "moveSiteAppliancesWizard": {
          "title": "Move appliance to... | Move {count} appliances to...",
          "subtitle": "Select target section",
          "message": "Target section should not contain any children. | Target section should not contain any children.",
          "toMigrate": "To migrate",
          "executeMigration": "Execute all migrations",
          "success": "Appliance migration have been executed successfully.",
          "error": "An error occurred while trying to execute the appliance migration."
        },
        "selectParentSection": {
          "title": "Select parent section",
          "subtitle": "Select target section",
          "destination": "Destination",
          "parent": "Parent",
          "to": "To",
          "choose": "Choose {sectionName}",
          "targetRoot": "The new section will be created at the site root"
        },
        "moveSection": {
          "message": {
            "success": "The section has been moved successfully.",
            "error": "An error occurred while trying to move the section."
          }
        }
      }
    },
    "veeValidate": {
      "code": "en",
      "messages": {
        "_default": "The field is not valid",
        "alpha": "The field may only contain alphabetic characters",
        "alpha_num": "The field may only contain alpha-numeric characters",
        "alpha_dash": "The field may contain alpha-numeric characters as well as dashes and underscores",
        "alpha_spaces": "The field may only contain alphabetic characters as well as spaces",
        "between": "The field must be between {min} and {max}",
        "confirmed": "The field confirmation does not match",
        "date": "The field must be a valid date",
        "digits": "The field must be numeric and exactly contain {length} digits",
        "dimensions": "The field must be {width} pixels by {height} pixels",
        "email": "The field must be a valid email",
        "not_one_of": "The field is not a valid value",
        "ext": "The field is not a valid file",
        "image": "The field must be an image",
        "integer": "The field must be an integer",
        "length": "The field must be {length} long",
        "max_value": "The field must be {max} or less",
        "max": "The field may not be greater than {length} characters",
        "mimes": "The field must have a valid file type",
        "min_value": "The field must be {min} or more",
        "min": "The field must be at least {length} characters",
        "numeric": "The field may only contain numeric characters",
        "one_of": "The field is not a valid value",
        "one_of_values": "The field is not a valid value ({values})",
        "not_one_of_values": "The field may not be one of the following: {values}",
        "regex": "The field format is invalid",
        "required_if": "The field is required when {target} has this value",
        "required": "The field is required",
        "size": "The field size must be less than {size}KB",
        "phoneNumber": "The field must be a valid phone number",
        "url": "The field is not a valid URL",
        "password_complexity_requirement": "Your password does not meet all the complexity requirements",
        "password_mismatch": "The passwords entered are not identical. Please check and try again.",
        "section_name_already_used": "An other section already has this name. Edit it to continue.",
        "errors": {
          "invalidType": "The field is required",
          "invalidTypeReceivedUndefined": "The field is required",
          "invalidString": {
            "email": "The field must be a valid email"
          },
          "programming_range": {
            "min_duration": "A programming should be at least 50 min"
          },
          "time": {
            "startNotPassed": "Start time must not be in the past"
          },
          "tooSmall": {
            "number": {
              "inclusive": "The field value must be equal or higher than {min}"
            },
            "string": {
              "inclusive": "The field must be at least {min} characters"
            }
          }
        }
      }
    },
    "wizard": {
      "piloting": {
        "temperature": "Temperature",
        "programmingDurationMode": {
          "duration": "Duration",
          "date-range": "Period"
        },
        "timezone": {
          "siteTimezoneInfo": "Manual settings will be executed in {timezone} time zone",
          "siteTimezoneWarning": "It seems that you are not in the same time zone ({clientTimezone}) as the site ({siteTimezone})"
        },
        "subtitle": {
          "create": "Apply a mode to a section",
          "edit": "Edit a mode"
        },
        "planMode": "Plan a mode",
        "availableModes": "Available modes",
        "modeHelpText": "This setting will be applied to your section selection",
        "duration": "Duration",
        "durationHelpText": "This setting will be applied for a specific duration",
        "dateRange": "Period",
        "dateRangeHelpText": "The setting will be applied for a period between two dates",
        "filterSectionsPlaceholder": "Search section",
        "messages": {
          "apply": {
            "success": "Manual control has been applied to selected sections",
            "error": "Error while applying manual control to some sections, please try again later..."
          },
          "edit": {
            "success": "Manual control has been edited",
            "error": "Error while editing manual control, please try again later..."
          }
        }
      }
    }
  }
};
